import { ref } from "vue"

const showAd = ref(false)
const upgradeAd = ref(false)

export { showAd, upgradeAd }
